var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew228({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 3,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.35,5.06A8.21,8.21,0,0,1,5.74,5a2.31,2.31,0,0,1,1.58.47,1.53,1.53,0,0,1,.5,1.18,1.66,1.66,0,0,1-.44,1.21,2.36,2.36,0,0,1-1.72.61,2.06,2.06,0,0,1-.58-.05v2.26H4.35Zm.73,2.72a2.41,2.41,0,0,0,.6.06c.87,0,1.41-.43,1.41-1.21s-.53-1.1-1.33-1.1a3.13,3.13,0,0,0-.68.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.7,9.75a2.55,2.55,0,0,0,1.3.36c.75,0,1.18-.39,1.18-1s-.3-.83-1.06-1.12c-.92-.32-1.49-.8-1.49-1.6A1.63,1.63,0,0,1,10.45,4.9a2.59,2.59,0,0,1,1.25.28l-.2.59a2.25,2.25,0,0,0-1.07-.26c-.77,0-1.06.46-1.06.84,0,.53.34.79,1.12,1.09.95.37,1.44.83,1.44,1.65s-.65,1.63-2,1.63a3,3,0,0,1-1.44-.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew228);
export default __webpack_public_path__ + "static/media/Symbolpack_New_228.36aa40c702250c89fa3d1be19dc3c2b5.svg";
export { ForwardRef as ReactComponent };